import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import HrShell from './components/HrShell.jsx';
import FinanceShell from './components/FinanceShell.jsx';
import WorkflowShell from './components/WorkflowShell.jsx';
import ProcurementShell from './components/ProcurementShell.jsx';
import PmShell from './components/PmShell.jsx';
import CrmShell from './components/CrmShell.jsx';
import DmsShell from './components/DmsShell.jsx';
import AnalyticsShell from './components/AnalyticsShell.jsx';
import AdminShell from './components/AdminShell.jsx';
import Login from './pages/Login.jsx';
import MfaVerify from './pages/MfaVerify.jsx';
import ForgotPassword from './pages/ForgotPassword.jsx';
import ResetPassword from './pages/ResetPassword.jsx';
import Dashboard from './pages/Dashboard.jsx';
import EmployeeDirectory from './pages/hr/EmployeeDirectory.jsx';
import EmployeeNew from './pages/hr/EmployeeNew.jsx';
import EmployeeProfile from './pages/hr/EmployeeProfile.jsx';
import OrgChart from './pages/hr/OrgChart.jsx';
import AttendanceDashboard from './pages/hr/AttendanceDashboard.jsx';
import Leave from './pages/hr/Leave.jsx';
import Payroll from './pages/hr/Payroll.jsx';
import Performance from './pages/hr/Performance.jsx';
import MyProfile from './pages/hr/MyProfile.jsx';
import ChartOfAccounts from './pages/finance/ChartOfAccounts.jsx';
import JournalEntries from './pages/finance/JournalEntries.jsx';
import Ledger from './pages/finance/Ledger.jsx';
import Vendors from './pages/finance/Vendors.jsx';
import VendorInvoices from './pages/finance/VendorInvoices.jsx';
import Customers from './pages/finance/Customers.jsx';
import CustomerInvoices from './pages/finance/CustomerInvoices.jsx';
import Payments from './pages/finance/Payments.jsx';
import Budgets from './pages/finance/Budgets.jsx';
import Banking from './pages/finance/Banking.jsx';
import Reports from './pages/finance/Reports.jsx';
import MyApprovals from './pages/workflow/MyApprovals.jsx';
import WorkflowDefinitions from './pages/workflow/WorkflowDefinitions.jsx';
import WorkflowBuilder from './pages/workflow/WorkflowBuilder.jsx';
import WorkflowInstances from './pages/workflow/WorkflowInstances.jsx';
import Notifications from './pages/workflow/Notifications.jsx';
import NotificationPreferences from './pages/workflow/NotificationPreferences.jsx';
import ResourceRedirect from './pages/workflow/ResourceRedirect.jsx';
import PurchaseRequests from './pages/procurement/PurchaseRequests.jsx';
import Rfqs from './pages/procurement/Rfqs.jsx';
import PurchaseOrders from './pages/procurement/PurchaseOrders.jsx';
import GoodsReceipts from './pages/procurement/GoodsReceipts.jsx';
import Inventory from './pages/procurement/Inventory.jsx';
import Warehouses from './pages/procurement/Warehouses.jsx';
import Products from './pages/procurement/Products.jsx';
import Suppliers from './pages/procurement/Suppliers.jsx';
import ProjectHub from './pages/pm/ProjectHub.jsx';
import Board from './pages/pm/Board.jsx';
import Backlog from './pages/pm/Backlog.jsx';
import Sprints from './pages/pm/Sprints.jsx';
import IssueDetail from './pages/pm/IssueDetail.jsx';
import Qa from './pages/pm/Qa.jsx';
import ReleasesPage from './pages/pm/Releases.jsx';
import PipelineBoard from './pages/crm/PipelineBoard.jsx';
import Deals from './pages/crm/Deals.jsx';
import Contacts from './pages/crm/Contacts.jsx';
import Companies from './pages/crm/Companies.jsx';
import Library from './pages/dms/Library.jsx';
import DocumentViewer from './pages/dms/DocumentViewer.jsx';
import Executive from './pages/analytics/Executive.jsx';
import HrAnalytics from './pages/analytics/HrAnalytics.jsx';
import FinanceAnalytics from './pages/analytics/FinanceAnalytics.jsx';
import ProjectAnalytics from './pages/analytics/ProjectAnalytics.jsx';
import QaAnalytics from './pages/analytics/QaAnalytics.jsx';
import ReportBuilder from './pages/analytics/ReportBuilder.jsx';
import EventsCalendar from './pages/events/EventsCalendar.jsx';
import OrgSettings from './pages/admin/OrgSettings.jsx';
import AdminUsers from './pages/admin/Users.jsx';
import RolesMatrix from './pages/admin/RolesMatrix.jsx';
import AdminWebhooks from './pages/admin/Webhooks.jsx';
import AdminApiKeys from './pages/admin/ApiKeys.jsx';
import AdminAuditLog from './pages/admin/AuditLog.jsx';
import AdminSystemHealth from './pages/admin/SystemHealth.jsx';
import AdminIntegrations from './pages/admin/Integrations.jsx';
import SupervisorRules from './pages/admin/SupervisorRules.jsx';
import AdminTags from './pages/admin/Tags.jsx';
import UserSupervisorConfig from './pages/admin/UserSupervisorConfig.jsx';
import OrgChartView from './pages/admin/OrgChartView.jsx';
import ProjectSettings from './pages/pm/ProjectSettings.jsx';
import Roadmap from './pages/pm/Roadmap.jsx';
import Timeline from './pages/pm/Timeline.jsx';
import SearchPage from './pages/search/SearchPage.jsx';
import SecuritySettings from './pages/settings/SecuritySettings.jsx';
import CommandPalette from './components/CommandPalette.jsx';
import WikiSpaces from './pages/wiki/Spaces.jsx';
import WikiSpaceLayout from './pages/wiki/SpaceLayout.jsx';
import WikiSpaceHome from './pages/wiki/SpaceHome.jsx';
import WikiPageView from './pages/wiki/PageView.jsx';
import WikiPageEditor from './pages/wiki/PageEditor.jsx';
import WikiSearchPage from './pages/wiki/Search.jsx';
import NotificationCenter from './pages/profile/NotificationCenter.jsx';
import NotificationPreferencesPage from './pages/profile/NotificationPreferencesPage.jsx';
import AppShell from './components/AppShell.jsx';
import PlusRoutes from './plus/PlusRoutes.jsx'; // BOS+ expansion (additive)

export default function App() {
  return (
    <>
    <CommandPalette />
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/search" element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
      <Route path="/settings/security" element={<ProtectedRoute><SecuritySettings /></ProtectedRoute>} />
      <Route path="/profile/notifications" element={<ProtectedRoute><NotificationCenter /></ProtectedRoute>} />
      <Route path="/profile/notifications/settings" element={<ProtectedRoute><NotificationPreferencesPage /></ProtectedRoute>} />

      {/* Wiki module */}
      <Route path="/wiki" element={<Navigate to="/wiki/spaces" replace />} />
      <Route element={<ProtectedRoute><AppShell flush /></ProtectedRoute>}>
        <Route path="/wiki/spaces" element={<WikiSpaces />} />
        <Route path="/wiki/search" element={<WikiSearchPage />} />
        <Route path="/wiki/:spaceKey" element={<WikiSpaceLayout />}>
          <Route index element={<WikiSpaceHome />} />
          <Route path=":pageSlug" element={<WikiPageView />} />
          <Route path=":pageSlug/edit" element={<WikiPageEditor />} />
        </Route>
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/mfa" element={<MfaVerify />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr"
        element={
          <ProtectedRoute>
            <HrShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/hr/employees" replace />} />
        <Route path="employees" element={<EmployeeDirectory />} />
        <Route path="employees/new" element={<EmployeeNew />} />
        <Route path="employees/:id" element={<EmployeeProfile />} />
        <Route path="org-chart" element={<OrgChart />} />
        <Route path="attendance" element={<AttendanceDashboard />} />
        <Route path="leave" element={<Leave />} />
        <Route path="payroll" element={<Payroll />} />
        <Route path="performance" element={<Performance />} />
        <Route path="me" element={<MyProfile />} />
      </Route>
      <Route
        path="/finance"
        element={
          <ProtectedRoute>
            <FinanceShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/finance/coa" replace />} />
        <Route path="coa" element={<ChartOfAccounts />} />
        <Route path="journal" element={<JournalEntries />} />
        <Route path="ledger" element={<Ledger />} />
        <Route path="vendors" element={<Vendors />} />
        <Route path="vendor-invoices" element={<VendorInvoices />} />
        <Route path="customers" element={<Customers />} />
        <Route path="customer-invoices" element={<CustomerInvoices />} />
        <Route path="payments" element={<Payments />} />
        <Route path="budgets" element={<Budgets />} />
        <Route path="budgets/:id" element={<Budgets />} />
        <Route path="banking" element={<Banking />} />
        <Route path="reports" element={<Reports />} />
      </Route>
      <Route
        path="/workflows"
        element={
          <ProtectedRoute>
            <WorkflowShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/workflows/my-approvals" replace />} />
        <Route path="my-approvals" element={<MyApprovals />} />
        <Route path="instances" element={<WorkflowInstances />} />
        <Route path="instances/:id" element={<WorkflowInstances />} />
        <Route path="resource/:resourceType/:resourceId" element={<ResourceRedirect />} />
        <Route path="definitions" element={<WorkflowDefinitions />} />
        <Route path="definitions/new" element={<WorkflowBuilder />} />
        <Route path="definitions/:id" element={<WorkflowBuilder />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="preferences" element={<NotificationPreferences />} />
      </Route>
      <Route
        path="/procurement"
        element={
          <ProtectedRoute>
            <ProcurementShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/procurement/requests" replace />} />
        <Route path="requests" element={<PurchaseRequests />} />
        <Route path="requests/:id" element={<PurchaseRequests />} />
        <Route path="rfqs" element={<Rfqs />} />
        <Route path="rfqs/:id" element={<Rfqs />} />
        <Route path="orders" element={<PurchaseOrders />} />
        <Route path="orders/:id" element={<PurchaseOrders />} />
        <Route path="receipts" element={<GoodsReceipts />} />
        <Route path="receipts/new" element={<GoodsReceipts />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="warehouses" element={<Warehouses />} />
        <Route path="products" element={<Products />} />
        <Route path="suppliers" element={<Suppliers />} />
      </Route>
      <Route
        path="/pm"
        element={
          <ProtectedRoute>
            <PmShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/pm/projects" replace />} />
        <Route path="projects" element={<ProjectHub />} />
        <Route path="qa" element={<Qa />} />
        <Route path="releases" element={<ReleasesPage />} />
        <Route path="issues/:key" element={<IssueDetail />} />
        <Route path="projects/:key" element={<Navigate to="board" replace />} />
        <Route path="projects/:key/board" element={<Board />} />
        <Route path="projects/:key/backlog" element={<Backlog />} />
        <Route path="projects/:key/sprints" element={<Sprints />} />
        <Route path="projects/:key/qa" element={<Qa />} />
        <Route path="projects/:key/releases" element={<ReleasesPage />} />
        <Route path="projects/:key/releases/:id" element={<ReleasesPage />} />
        <Route path="projects/:key/settings" element={<ProjectSettings />} />
        <Route path="projects/:key/roadmap" element={<Roadmap />} />
        <Route path="projects/:key/timeline" element={<Timeline />} />
      </Route>
      <Route
        path="/crm"
        element={
          <ProtectedRoute>
            <CrmShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/crm/pipeline" replace />} />
        <Route path="pipeline" element={<PipelineBoard />} />
        <Route path="deals" element={<Deals />} />
        <Route path="deals/:id" element={<Deals />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="companies" element={<Companies />} />
      </Route>
      <Route
        path="/dms"
        element={
          <ProtectedRoute>
            <DmsShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Library />} />
        <Route path=":id" element={<DocumentViewer />} />
      </Route>
      <Route
        path="/analytics"
        element={
          <ProtectedRoute>
            <AnalyticsShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Executive />} />
        <Route path="finance" element={<FinanceAnalytics />} />
        <Route path="hr" element={<HrAnalytics />} />
        <Route path="projects" element={<ProjectAnalytics />} />
        <Route path="qa" element={<QaAnalytics />} />
        <Route path="reports" element={<ReportBuilder />} />
      </Route>
      <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route path="/events" element={<EventsCalendar />} />
      </Route>
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<OrgSettings />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="roles" element={<RolesMatrix />} />
        <Route path="webhooks" element={<AdminWebhooks />} />
        <Route path="api-keys" element={<AdminApiKeys />} />
        <Route path="integrations" element={<AdminIntegrations />} />
        <Route path="audit" element={<AdminAuditLog />} />
        <Route path="health" element={<AdminSystemHealth />} />
        <Route path="supervisor-rules" element={<SupervisorRules />} />
        <Route path="tags" element={<AdminTags />} />
        <Route path="org-chart" element={<OrgChartView />} />
        <Route path="users/:id/supervisor-config" element={<UserSupervisorConfig />} />
      </Route>
      {/* BOS+ expansion (additive) — plus module routes, rendered once. */}
      {PlusRoutes()}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
    </>
  );
}
